import {ComponentType} from 'react';
import {Diff} from 'utility-types';

import {Signatures, SignaturesProps} from './signatures';
import {SignaturesEnhancerInjectedProps, SignaturesEnhancerProps, withSignatures} from './withSignatures';

/*
 * Props.
 */

export interface SignaturesContainerProps
  extends SignaturesEnhancerProps,
    Diff<SignaturesProps, SignaturesEnhancerInjectedProps> {}

/*
 * Component.
 */

export const SignaturesContainer: ComponentType<SignaturesContainerProps> = withSignatures(Signatures);
